type HiddenAnchorRecord = {
  id?: string
  anchorId?: string
}

export const HiddenAnchor = ({ record }: { record: HiddenAnchorRecord }) => {
  return <a id={record.anchorId}></a>
}
